export const meta = {
  id: 'C02',
  slug: 'competencia',
  title: 'O que é uma Competência?',
  description: 'Entenda como Competências, Níveis e Descritores ajudam a tornar o desenvolvimento mais claro e acompanhável.',
  profile: 'student',
  category: 'conceitos',
  type: 'concept',
  status: 'published',
  order: 195,
  keywords: ['competência', 'competencias', 'nível', 'niveis', 'descritor', 'descritores', 'comportamento', 'desenvolvimento'],
  previous: 'C01',
  next: 'C03',
  related: ['A02', 'A03', 'C01'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# O que é uma Competência?

Uma **Competência** representa uma capacidade relevante para alcançar resultados e se desenvolver. No Personagrama, ela não é tratada apenas como um nome: pode ser organizada em níveis e descritores comportamentais que ajudam a tornar a avaliação mais clara.

## Competência

É aquilo que está sendo desenvolvido ou acompanhado, como liderança, organização, negociação, relacionamento interpessoal ou outra capacidade definida pela metodologia utilizada.

## Nível

Representa um grau de desenvolvimento daquela Competência.

O nível ajuda a indicar o momento atual, mas seu significado depende dos comportamentos descritos para aquela faixa.

## Descritor comportamental

Explica **como aquele nível se manifesta na prática**. Em vez de depender apenas de termos vagos como “bom” ou “avançado”, o descritor oferece referências observáveis.

## Como as partes se conectam

**Competência → Níveis → Descritores → Diagnóstico → Desenvolvimento.**

Essa estrutura ajuda você, seu Mentor e a administração da metodologia a utilizar uma linguagem comum para avaliar prioridades e acompanhar evolução.

<Callout type="important">
  Um nível não define permanentemente quem você é. Ele funciona como referência para compreender seu momento atual e orientar desenvolvimento.
</Callout>